import React from 'react';
import Image from 'next/image';
import downArrowNext from '../../svgs/down_arrow_icon.svg';
import { NextImageProps } from '../NextImageProps';

export function DownArrowNext({ className, width, height, alt }: NextImageProps) {
  return (
    <Image
      width={width}
      height={height}
      className={className}
      src={downArrowNext}
      alt={alt ?? 'Ned'}
    />
  );
}
